import { createFileRoute, useParams } from "@tanstack/react-router";
import { ExceptionsPage } from "../features/exceptions/pages/exceptions-page";

export const Route = createFileRoute("/tenants/$tenantId/health")({
  component: TenantHealthRoute,
});

/** The same four questions as `/exceptions`, asked about one roastery (US-14.6). */
function TenantHealthRoute() {
  const { tenantId } = useParams({ from: "/tenants/$tenantId" });
  return <ExceptionsPage tenantId={tenantId} />;
}
